// src/components/core/cards/index.js
/**
 * Consolidated Card Components Module
 * 
 * This module provides the primary implementation of EntityCard components used throughout the application.
 * All card components have been consolidated in this module to ensure consistency and reduce duplication.
 * 
 * IMPORTANT: When working with entity cards:
 * - For general card needs, use EntityCard with appropriate entityType
 * - For specific entity types, use the specialized card components (BrandCard, CampaignCard, etc.)
 * - BaseCard provides foundation for other cards if you need to create new card variants
 */

// Import components from design-system
import { EntityCard } from '../../../design-system/components/data';

// Export consolidated components
export { EntityCard };
export const BaseCard = EntityCard; // BaseCard is just an alias for EntityCard

// Legacy component for backward compatibility - deprecated
// Use design system Card component for new development
// export { default as MagicCard } from '../../ui/MagicCard';

// Specialized entity card components for different entity types
// These are wrappers that pass the entity directly to EntityCard with the correct entityType

// BrandCard - For brand entities
export const BrandCard = (props) => (
  <EntityCard
    entityType="brand"
    data={props.brand}
    {...props}
  />
);

// CampaignCard - For campaign entities
export const CampaignCard = (props) => (
  <EntityCard entityType="campaign" data={props.campaign} {...props} />
);

// ProjectCard - For project entities
export const ProjectCard = (props) => (
  <EntityCard entityType="project" data={props.project} {...props} />
);

// ClientCard - For client entities
export const ClientCard = (props) => (
  <EntityCard entityType="client" data={props.client} {...props} />
);

// ContentCard - For content entities
export const ContentCard = (props) => (
  <EntityCard entityType="content" data={props.content} {...props} />
);

// TaskCard - For task entities
export const TaskCard = (props) => (
  <EntityCard entityType="task" data={props.task} {...props} />
);